
angular.module('psModule').component('customerOfferModal', {
    template:'<div class="modal fade bd-example-modal-lg" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button id="close-modal" type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h2>Erbjudande från Max Matthiessen</h2></div><div class="modal-body"><div class="container-box" ng-repeat="offer in $ctrl.offers"><div class="box" ng-style="{\'background-color\': offer.backgroundColor}"><div class="flex-box"><div class="text-box"><h2 ng-style="{\'color\': offer.headerColor}">{{offer.header}}</h2><ng-container ng-if="!offer.offerSavedOk"><p ng-style="{color: offer.bodyTextColor}">{{offer.bodyText}}</p><p class="small" ng-if="offer.smallText" ng-style="{color: offer.smallTextColor}">{{offer.smallText}}</p><div ng-if="offer.type == \'STANDARD_TEXT_W_TWO_ALTERNATIVES\'"><div class="accept-box"><a ng-click="$ctrl.saveWantedOffers(offer, true)" href>{{offer.checkboxLabel}}</a> <a ng-click="$ctrl.saveWantedOffers(offer, false)" href>Jag hoppar över detta erbjudande denna gång.</a></div><p ng-if="offer.linkReadMore">{{offer.readMoreText}}<a href="{{offer.linkReadMore}}" target="_blank">här.</a></p></div><div ng-if="offer.type == \'READMORE_AS_YES_BUTTON\'"><div class="accept-box"><button type="button" class="btn btn-link" style="color: {{offer.buttonTextColor}}; background-color: {{offer.buttonBackgroundColor}}; border-color: {{offer.buttonBackgroundColor}};" ng-click="$ctrl.saveWantedOffersAndOpenLink(offer, true, offer.linkReadMore);">{{offer.readMoreText}}</button> <a ng-click="$ctrl.saveWantedOffers(offer, false)" href>Jag hoppar över detta erbjudande denna gång.</a></div></div><p ng-if="offer.offerSavedFailed">Något gick fel</p></ng-container><ng-container ng-if="offer.offerSavedOk"><div class="box"><div ng-if="offer.offerSavedOk && offer.answer" class="container-checkbox"><svg id="Layer_2" class="on" viewBox="0 0 84 84"><defs><style>.cls-1{fill:none;stroke:#004478;stroke-miterlimit:10;stroke-width:2px;}</style></defs><circle class="cls-1" cx="42" cy="42" r="41"></circle></svg><svg id="Layer_1" class="on" viewBox="0 0 24 19"><defs><style>.cls-2{fill:none;stroke:#004478;stroke-miterlimit:10;stroke-width:1.3px;}</style></defs><polyline class="cls-2" points="2.09 9.56 8.3 15.77 22.19 1.87"></polyline></svg></div><div class="visa"><h2 ng-if="offer.answer">Vi kommer kontakta dig inom kort</h2></div></div></ng-container></div></div><div class="frame"><span class="helper"></span> <img class="img-box" style="vertical-align: middle;" ng-src="{{offer.imageLink}}"></div></div></div></div><div class="modal-footer"><a ng-click="$ctrl.noMoreOffers()" href>Jag vill inte ha fler erbjudanden!</a></div></div></div></div>',
    bindings: {
        offers: '<',
        user:'<',
    },
    controller: CustomerOfferModalController
});

function CustomerOfferModalController($resource, faktainsamlingService, $http){
    const ctrl = this;

    $('#exampleModal').modal('show');



    ctrl.onClick = () => {
        $('#exampleModal').modal('show');
    }


    ctrl.closeModal = () => {
        $('#exampleModal').modal('hide');
        $('.modal-backdrop').remove();
    }

    ctrl.noMoreOffers = () => {

            const data = {
                wantOffers: false,
                ssn: ctrl.user.ssn,
            }
            $http.post('/ps/api/customer-settings', data).then(response => {
                ctrl.closeModal();

            }).catch(e => {
            })
    }
    ctrl.saveWantedOffersAndOpenLink = (offer, acceptOffer, linkUrl) => {
        ctrl.saveWantedOffers(offer,acceptOffer);
        ctrl.closeModal();
        window.open(linkUrl, '_blank').focus();

    }
    ctrl.saveWantedOffers =  (offer, acceptOffer) => {
        const data = {
            offerId: offer.id,
            ssn: ctrl.user.ssn,
            acceptOffer: acceptOffer
        }

        offer.offerSavedOk = undefined;
        offer.offerSavedFailed = undefined;

        $http.post('/ps/api/customer-offers', data).then(response => {
                offer.offerSavedOk = true;
                offer.answer = response.data.acceptOffer;

                if(!offer.answer){

                    ctrl.offers.splice(ctrl.offers.indexOf(offer),1);
                    if(!ctrl.offers.length){
                        ctrl.closeModal();
                    }
                }


        }).catch(e => {
            offer.offerSavedFailed = true;
            offer.answer = response.data.acceptOffer;
        })
    }

}
